import React from "react";
import { FormControlLabel, Checkbox, Tooltip, Box } from "@mui/material";
import { useFormikContext } from "formik";

export interface GenericCheckboxFieldProps {
  name: string;
  label: string;
  disabled?: boolean;
  tooltip?: string;
  size?: "small" | "medium";
}

const GenericCheckboxField: React.FC<GenericCheckboxFieldProps> = ({
  name,
  label,
  disabled = false,
  tooltip,
  size = "small",
}) => {
  const { values, setFieldValue } = useFormikContext<any>();

  // Helper function to get nested values safely
  const getNestedValue = (obj: any, path: string): any => {
    return path.split('.').reduce((current, key) => current?.[key], obj);
  };

  const fieldValue = Boolean(getNestedValue(values, name));

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(name, event.target.checked);
  };

  const checkboxField = (
    <FormControlLabel
      control={
        <Checkbox
          name={name}
          checked={fieldValue}
          onChange={handleChange}
          disabled={disabled}
          size={size}
        />
      }
      label={label}
      sx={{ mb: 1 }}
    />
  );

  return tooltip ? (
    <Tooltip title={tooltip} placement="top">
      <Box>{checkboxField}</Box>
    </Tooltip>
  ) : (
    checkboxField
  );
};

export default GenericCheckboxField;
